<template>
  <div v-if="isPublicOrMember">
      <div v-if="projectId && !projectLoading" class="">
      <b-container class="mx-auto">
        <b-row class="mx-auto" align-h="between" no-gutters>
          <b-col>
            <h3 class="mb-0">Photos</h3>
          </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-between">
          <div class="my-1 col-md-4">
            Showing {{ fromItem }} to {{ toItem }} of
            {{ totalItems }}
            {{ isManager ? 'observation' :
            isMember ? 'public and your private observation' :
              'public observation'}}<span v-if="totalItems === 0 || totalItems > 1">s</span>
          </div>

          <div class="col-md-3 my-1">
            <b-pagination
              v-if="totalItems > 0"
              :total-rows="totalItems"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0 pagination-holder"
              prev-text="Prev"
              next-text="Next"
              align="fill"
            />
          </div>

          <div class="col-md-3 my-1">
            <b-form-group
              label="Per Page"
              label-align="right"
              label-cols-sm="7"
              label-cols-md="8"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
                align="right"
              >
              </b-form-select>
            </b-form-group>
          </div>
        </b-row>

        <b-row class="section observation mx-0">
          <PhotoObservationCard
            v-for="(observation, index) in photoObservations"
            :key="index"
            :observation="observation"
            :isProjectPage=true
            :isObservationPage=false
            class="m-2">
          </PhotoObservationCard>
        </b-row>
        <b-table
          :items="observations"
          :current-page="currentPage"
          :per-page="perPage"
          class="d-none"
        >
        </b-table>

        <div class="card-footer">
          <div class="row justify-content-between">
            <div class="my-1 col-md-4">
              Showing {{ fromItem }} to {{ toItem }} of
              {{ totalItems }}
              {{ isManager ? 'observation' :
              isMember ? 'public and your private observation' :
                'public observation'}}<span v-if="totalItems === 0 || totalItems > 1">s</span>
            </div>

            <div class="col-md-3 my-1">
              <b-pagination
                v-if="totalItems > 0"
                :total-rows="totalItems"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0 pagination-holder"
                prev-text="Prev"
                next-text="Next"
                align="fill"
              />
            </div>

            <div class="col-md-3 my-1">
              <b-form-group
                label="Per Page"
                label-align="right"
                label-cols-sm="7"
                label-cols-md="8"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                  align="right"
                >
                </b-form-select>
              </b-form-group>
            </div>
          </div>
        </div>
      </b-container>
    </div>
    <RequiresMember v-else page="Photos"></RequiresMember>
  </div>
</template>

<script>
import RequiresMember from "../tabpermission/requiresMember.vue";
import { mapActions, mapGetters } from "vuex";
import PhotoObservationCard from "../../../layout/PhotoObservationCard.vue";

export default {
  components: {
    RequiresMember,
    PhotoObservationCard
  },
  data() {
    return {
      pageOptions: [10, 25, 50, 100, 250, 500],
      photoObservations: null
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      projectId: "project/get/id",
      projectLoading: "project/get/isLoading",
      isPublicOrMember: "project/get/isPublicOrMember",
      isManager: "project/get/isManager",
      isMember: "project/get/isMember",

      observationPage: "project/get/observationPage",
      observationItems: "project/get/observationItems",
      observationTotal: "project/get/observationTotal",
    }),
    currentPage: {
      get() {
        return this.observationPage
      },
      set(newValue) {
        this.setObservationTablePage(newValue)
      }
    },
    totalItems: {
      get() {
        return this.observationTotal
      },
      set(newValue) {
        this.setObservationTableTotal(newValue)
      }
    },
    perPage: {
      get() {
        return this.observationItems
      },
      set(newValue) {
        this.setObservationTableItems(newValue)
      }
    },
    fromItem() {
      return this.totalItems > 0
        ? (this.currentPage - 1) * this.perPage + 1
        : 0;
    },
    toItem() {
      console.log(this.totalItems, this.currentPage, this.perPage)
      return this.totalItems < this.currentPage * this.perPage
        ? this.totalItems
        : this.currentPage * this.perPage;
    },
  },

  methods: {
    ...mapActions({
      getPhotoObservations: "observation/list/getObservationsList",

      setObservationTablePage: "project/get/setObservationTablePage",
      setObservationTableItems: "project/get/setObservationTableItems",
      setObservationTableTotal: "project/get/setObservationTableTotal",
    }),
    observations(ctx) {
      let urlParams = `${this.urlBuilder(ctx)}` + '&order[observedAt]=desc&exists[featuredPhoto]';
      const data = {id: this.projectId, urlParams};
      return this.getPhotoObservations(data).then(data => {
        this.totalItems = data["hydra:totalItems"];
        this.currentPage = ctx.currentPage || 1;
        this.photoObservations = data["hydra:member"]
      });
    },
  }
};
</script>

<style></style>
